import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'tabler-react';
import Input from "../Playgrond/Input/index";
import fetch from '../../support/fetch';


const propTypes = {
    subscription: PropTypes.object.isRequired
};

class CouponManager extends Component {
    state = {
        opened: false,
        showLoader: false,
        inputState: 'normal',
        feedbackText: 'Cupom inválido',
        showFeedbackText: false,
        coupon_code: null,
        inputOk: false
    };

    componentDidMount() {
        // console.log(this.props.subscription);
    }

    openFormHandler = e => {
        e.preventDefault();

        this.setState({
            opened: true
        });

    };

    inputOnChangeHandler = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    submitFormHandler = e => {

        e.preventDefault();

        if (this.state.coupon_code.length < 3) {
            this.setState({
                showFeedbackText: true,
                inputState: 'error',
                feedbackText: 'Cupom inválido'
            });

            return;
        } else {
            this.setState({
                showFeedbackText: false,
                inputState: 'normal',
                inputFeedbackText: '',
                showLoader: true
            });
        }

        const query = `mutation AddNewCouponToSubscription($subscription_id: ID!, $coupon_code: String!) {
            addCouponToSubscription(subscription_id: $subscription_id, coupon_code: $coupon_code) {
                id
            }
        }
        `;

        fetch.obj({
            query: query,
            variables: {
                subscription_id: this.props.subscription.id,
                coupon_code: this.state.coupon_code
            }
        })
        .then(res => {

            if (res.hasOwnProperty('errors')) {
                const error = res.errors[0].validation.coupon_code[0];

                this.setState({
                    feedbackText: error,
                    showFeedbackText: true,
                    inputState: 'error',
                    showLoader: false
                });

                return;
            }

            this.setState({
                feedbackText: 'Cupom adicionado com sucesso!',
                showFeedbackText: true,
                inputState: 'success',
                showLoader: false,
                inputOk: true
            });
        });
    };

    closeFormHandler = e => {
        e.preventDefault();

        this.setState({
            opened: false
        });
    };

    render () {
        return (
            <Card className="p-5">
                <div className="d-flex">
                <span className="stamp stamp-md bg-azure mr-3">
                    <i className="fe fe-tag"/>
                </span>
                    {
                        ! this.state.opened &&
                        <div>
                            <div className="h4 mb-2">
                                {
                                    this.props.subscription.coupon === null &&
                                    "Não há cupom vinculado"
                                }

                                {
                                    this.props.subscription.coupon !== null &&
                                    "Cupom Vinculado: " + this.props.subscription.coupon.code
                                }
                            </div>
                            {/*
                                <p className="mb-0">
                                    Clique <a href="#" onClick={this.openFormHandler}>aqui</a> para vincular um novo{' '}
                                    cupom de desconto à esta assinatura.
                                </p>
                            */}

                            <p>
                                Você possui uma assinatura ativa! 
                                Para utilizar um novo cupom é necessário o cancelamento 
                                da sua assinatura atual e a criação de uma nova.
                            </p>
                        </div>
                    }

                    {
                        this.state.opened &&
                        <div>
                            <div className="h4 mb-1">Aplicar Novo Cupom</div>

                            <p className="mb-3">
                                Informe o seu cupom no campo abaixo e clique em aplicar.
                            </p>

                            <form onSubmit={this.submitFormHandler} autoComplete="off">
                                <div className="row gutters-xs">
                                    <div className="col">
                                        <Input
                                            name="coupon_code"
                                            type="text"
                                            state={this.state.inputState}
                                            showFeedbackText={this.state.showFeedbackText}
                                            feedbackText={this.state.feedbackText}
                                            required={!this.state.inputOk}
                                            disabled={this.state.showLoader}
                                            pipe={ v => v.toUpperCase() }
                                            ok={this.state.inputOk}
                                            onChange={this.inputOnChangeHandler}
                                        />
                                    </div>
                                    <div className="col col-auto">
                                        <Button
                                            className={
                                                "btn " &&
                                                !this.state.showLoader ? "btn-outline-primary" : "btn-primary"
                                            }
                                            loading={this.state.showLoader}
                                        >
                                            aplicar
                                        </Button>
                                    </div>
                                </div>
                            </form>

                            <div className="mt-3">
                                <a href="#" className="small" onClick={this.closeFormHandler}>cancelar</a>
                            </div>
                        </div>
                    }
                </div>
            </Card>
        );
    }
};

CouponManager.propTypes = propTypes;

export default CouponManager;